module.exports = __webpack_public_path__ + "assets/1e7669e67e3cf65252dfd1aaae108ee1.png";